export enum TypeCalification {
  HAPPY,
  SATISFIED,
  UNHAPPY,
}
